// extracted by css-extract-rspack-plugin
export default {"cls1":"Spinner-cls1_xws","cls2":"Spinner-cls2_DIl Spinner-cls1_xws","rotate-spinner":"Spinner-rotate-spinner_IRr"};